import { useContext } from 'react';
import { WrittenLogo } from 'assets/icons';
import { Button, ButtonSize, ButtonStyle } from 'common/button';
import { AppContext } from 'context/app-context';
import { goToPage, RouteName } from 'routes';
import styles from './public-top-bar.module.scss';

interface PublicTopBarProps {
  // The vault or album being viewed; none for a single shared memory.
  title?: string;
}

// Top bar of the public view mode (shared links and QR codes), in place of the
// owner's vault top bar: the logo, what's being viewed, and a way in for
// visitors (log in / create a vault) or back to your vaults when signed in.
export const PublicTopBar = ({ title }: PublicTopBarProps) => {
  const { state } = useContext(AppContext);

  return (
    <nav className={styles.topBar}>
      <div className={styles.leftSection}>
        <span className={styles.logo}>
          <WrittenLogo />
        </span>
        {title && (
          <span className={styles.title} title={title}>
            {title}
          </span>
        )}
      </div>
      <div className={styles.rightSection}>
        {state.logged ? (
          <Button
            buttonStyle={ButtonStyle.SecondaryGray}
            buttonSize={ButtonSize.Medium}
            onClick={() => goToPage(RouteName.Vaults)}
          >
            My vaults
          </Button>
        ) : (
          <>
            <Button
              buttonStyle={ButtonStyle.SecondaryGray}
              buttonSize={ButtonSize.Medium}
              onClick={() => goToPage(RouteName.SignIn)}
            >
              Log in
            </Button>
            {/* Both go to sign in; a phone has room for one. */}
            <Button
              buttonStyle={ButtonStyle.Primary}
              buttonSize={ButtonSize.Medium}
              className={styles.createVault}
              onClick={() => goToPage(RouteName.SignIn)}
            >
              Create a Vault
            </Button>
          </>
        )}
      </div>
    </nav>
  );
};
